import React, { useCallback, useState } from 'react';
import { InputGroup, InputLeftElement, Input, InputRightElement, useColorMode } from '@chakra-ui/react';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';

import { useCalendarSettings, useFilters } from '../../../../lib/context';

interface ISearchFilterProps {}

export const SearchFilter: React.FC<ISearchFilterProps> = () => {
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();
	const { searchTerm, setSearchTerm } = useFilters();
	const [showClearIcon, setShowClearIcon] = useState(false);

	const handleSearchChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			setSearchTerm(value);
			setShowClearIcon(value.length > 0);
		},
		[setSearchTerm, setShowClearIcon]
	);

	const clearSearch = useCallback(() => {
		setSearchTerm('');
		setShowClearIcon(false);
	}, [setSearchTerm, setShowClearIcon]);
	const { filtersTextColor, calendarBordersColor } = settings.styles[colorMode];
	return (
		<InputGroup>
			<InputLeftElement pointerEvents='none'>
				<SearchIcon color='gray.300' />
			</InputLeftElement>
			<Input
				placeholder='Search events'
				borderRadius='xs'
				borderColor={calendarBordersColor}
				value={searchTerm}
				onChange={handleSearchChange}
				color={filtersTextColor}
				sx={{
					'::placeholder': {
						color: filtersTextColor,
					},
				}}
			/>
			{showClearIcon && (
				<InputRightElement>
					<CloseIcon cursor='pointer' color='gray.500' onClick={clearSearch} />
				</InputRightElement>
			)}
		</InputGroup>
	);
};
